import { format } from 'date-fns';

export const TERMINABLE_TASK_STATUSES = ['waiting', 'processing', 'executing', 'pending'];
export const RETRYABLE_TASK_STATUSES = ['partial', 'canceled', 'cancelled', 'failed'];

export function isTerminableTaskStatus(status) {
  return TERMINABLE_TASK_STATUSES.includes(String(status || ''));
}

export function isRetryableTaskStatus(status) {
  return RETRYABLE_TASK_STATUSES.includes(String(status || ''));
}

/** 终止后写入后端的任务 patch（含合法 finishedAt）；failedCount 仅含已处理失败，不含未处理项 */
export function buildTerminatedTaskApiPatch({ total, successCount, failedCount = 0 }) {
  const safeTotal = Number(total) || 0;
  const safeSuccess = Math.min(Math.max(0, Number(successCount) || 0), safeTotal);
  const safeFailed = Math.min(
    Math.max(0, Number(failedCount) || 0),
    Math.max(0, safeTotal - safeSuccess),
  );
  return {
    status: 'partial',
    total: safeTotal,
    successCount: safeSuccess,
    failedCount: safeFailed,
    finishedAt: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
  };
}

/** 重试时写入后端（勿传 finishedAt: "—"） */
export function buildRetryTaskApiPatch({ total, successCount, failedCount = 0 }) {
  const safeTotal = Number(total) || 0;
  const safeSuccess = Math.min(Math.max(0, Number(successCount) || 0), safeTotal);
  const safeFailed = Math.min(
    Math.max(0, Number(failedCount) || 0),
    Math.max(0, safeTotal - safeSuccess),
  );
  return {
    status: 'processing',
    total: safeTotal,
    successCount: safeSuccess,
    failedCount: safeFailed,
  };
}
